import e, { Component as t } from "react";
import { componentName as r } from "../../../utils/bem/index.js";
import { removeEmojis as o } from "../../../utils/removeEmojis/index.js";
import { FormLabel as n } from "../Label/FormLabel.js";
import { BACKSPACE as s, ENTER as i, ESC as p } from "../../../constants/keyboard.js";
import { extractAriaProps as a } from "../../../utils/props/index.js";
import { Icon as l } from "../../general/Icon/Icon.js";
import c from "../../../../node_modules/classnames/index.js";
function u(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function f(e, t) {
  for (var r = 0; r < t.length; r++) {
    var o = t[r];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function h(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function d(e) {
  return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function y(e, t) {
  return (y = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var m = function m(e, t) {
    return e || 0 === e ? e : t;
  },
  b = function (t) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && y(e, t);
    }(j, t);
    var b,
      v,
      O,
      g = (b = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (e) {
          return !1;
        }
      }(), function () {
        var e,
          t,
          r = d(j);
        if (b) {
          var o = d(this).constructor;
          t = Reflect.construct(r, arguments, o);
        } else t = r.apply(this, arguments);
        return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : u(this);
      });
    function j() {
      var e;
      return !function (e, t) {
        if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
      }(this, j), e = g.apply(this, arguments), h(u(e), "input", void 0), h(u(e), "focus", function () {
        var t;
        return null === (t = e.input) || void 0 === t ? void 0 : t.focus();
      }), h(u(e), "_handleFieldChange", function (t) {
        return e.props.onChange(o(t.target.value));
      }), h(u(e), "_handleKeyDown", function (t) {
        var r, o, n, a, l, c, u, f;
        switch (t.keyCode) {
          case p:
            null === (n = (a = e.props).onEsc) || void 0 === n || n.call(a);
            break;
          case i:
            null === (l = (c = e.props).onEnter) || void 0 === l || l.call(c);
            break;
          case s:
            null === (u = (f = e.props).onBackspace) || void 0 === u || u.call(f);
        }
        null === (r = (o = e.props).onKeyDown) || void 0 === r || r.call(o, t);
      }), h(u(e), "_handleFocus", function (t) {
        var r, o;
        e.props.autoSelect && t.target.select(), null === (r = (o = e.props).onFocus) || void 0 === r || r.call(o, t);
      }), h(u(e), "_receiveInput", function (t) {
        return e.input = t;
      }), e;
    }
    return v = [{
      key: "componentDidMount",
      value: function value() {
        if (this.props.autoFocus && !this.props.autoSelect) {
          var e = this.input.value;
          this.input.value = "", this.input.value = e;
        }
      }
    }, {
      key: "render",
      value: function value() {
        var t,
          o,
          s = this.props,
          i = s.disabled,
          p = s.readOnly,
          u = s.showRevealOption,
          f = s.value,
          d = this.props.autoComplete ? "on" : "off",
          y = r("text-field", "qa-form-text-field", this.props.className, {
            disabled: i,
            readOnly: p,
            revealable: u,
            valueEntered: !!f
          });
        return e.createElement(n, {
          className: y,
          value: this.props.label,
          errorMessage: this.props.errorMessage,
          hint: this.props.helpText,
          isRequired: this.props.isRequired
        }, e.createElement("div", {
          className: c("text-field__input-container", this.props.errorMessage && "text-field__input-container--error")
        }, e.createElement(this.props.textArea ? "textarea" : "input", (t = function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var r = null != arguments[t] ? arguments[t] : {},
              o = Object.keys(r);
            "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
              return Object.getOwnPropertyDescriptor(r, e).enumerable;
            }))), o.forEach(function (t) {
              h(e, t, r[t]);
            });
          }
          return e;
        }({}, a(this.props)), o = o = {
          ref: this._receiveInput,
          onFocus: this._handleFocus,
          onBlur: this.props.onBlur,
          onKeyPress: this.props.onKeyPress,
          onKeyDown: this._handleKeyDown,
          onMouseDown: this.props.onMouseDown,
          onChange: this._handleFieldChange,
          placeholder: this.props.placeholder,
          readOnly: this.props.readOnly,
          type: this.props.reveal ? "text" : this.props.type,
          maxLength: this.props.maxLength,
          value: m(this.props.value, ""),
          min: this.props.min,
          max: this.props.max,
          step: this.props.step,
          name: this.props.name,
          inputMode: this.props.inputMode,
          autoComplete: d,
          disabled: this.props.disabled,
          autoFocus: this.props.autoFocus
        }, Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(o)) : function (e, t) {
          var r = Object.keys(e);
          if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r.push.apply(r, o);
          }
          return r;
        }(Object(o)).forEach(function (e) {
          Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(o, e));
        }), t)), this.props.showRevealOption && e.createElement(l, {
          fw: !0,
          regular: !0,
          className: "text-field__reveal-icon",
          name: this.props.reveal ? "fa-eye-slash" : "fa-eye",
          onClick: this.props.onToggleReveal
        }), this.props.children && e.createElement("div", {
          className: "text-field__accessories"
        }, this.props.children)));
      }
    }], f(j.prototype, v), O && f(j, O), j;
  }(t);
h(b, "displayName", "StatelessTextField"), h(b, "defaultProps", {
  value: "",
  type: "text"
});
export { b as TextFieldStateless, m as isTruthyOr0 };